module.exports = __webpack_public_path__ + "static/media/space_stars.1bac1485.svg";